import { createSignal } from "solid-js";

import BasicQuestionForm from "./steps/BasicQuestion";
import { useTranslator } from "../context/TranslatorContext";

import image from "../assets/images/slide-1.jpg";
import image2 from "../assets/images/slide-2.jpg";
import image3 from "../assets/images/slide-3.jpg";
import image4 from "../assets/images/slide-4.jpg";
import image5 from "../assets/images/slide-5.jpg";

import posthog from "posthog-js";

import { urlParams } from "../store/UrlParameters";

export default function StepManager() {
  const { t } = useTranslator();
  const [currentStepIndex, setCurrentStepIndex] = createSignal(0);
  const [visible, setVisible] = createSignal(true);

  function next(data) {
    posthog.capture(data.id, {
      $set: {
        answer: data.button,
      },
    });

    if (currentStepIndex() == 4) {
      redirect();
      return;
    }

    setVisible(false);

    setTimeout(() => {
      setCurrentStepIndex((i) => {
        return i + 1;
      });
      setVisible(true);
    }, 400);
  }

  function redirect() {
    const trackingDomain = urlParams().trk_dom || "trk.fcktht.com";
    window.location.href = `https://${trackingDomain}/click`;
  }

  return (
    <div
      class="fade flex w-full flex-col"
      classList={{ "fade-out": !visible(), "fade-in": visible() }}
    >
      <Show when={currentStepIndex() == 0}>
        <BasicQuestionForm
          id="question_exchange_photos"
          image={image}
          question={() => (
            <>
              <h1 class="text-2xl font-extrabold uppercase">
                {t("steps.question_exchange_photos.title")}
              </h1>
              <p>
                {t("steps.question_exchange_photos.text1", {
                  state: urlParams().state,
                })}
              </p>
              <p>{t("steps.question_exchange_photos.text2")}</p>
            </>
          )}
          buttons={[
            { text: t("steps.question_exchange_photos.buttonNo"), id: "no" },
            { text: t("steps.question_exchange_photos.buttonYes"), id: "yes" },
          ]}
          next={next}
        ></BasicQuestionForm>
      </Show>

      <Show when={currentStepIndex() == 1}>
        <BasicQuestionForm
          id="question_agree_keep_secret"
          image={image2}
          question={() => (
            <>
              <p>{t("steps.question_agree_keep_secret.text1")}</p>
              <p>{t("steps.question_agree_keep_secret.text2")}</p>
            </>
          )}
          buttons={[
            { text: t("steps.question_exchange_photos.buttonNo"), id: "no" },
            { text: t("steps.question_exchange_photos.buttonYes"), id: "yes" },
          ]}
          next={next}
        ></BasicQuestionForm>
      </Show>

      <Show when={currentStepIndex() == 2}>
        <BasicQuestionForm
          id="question_agree_only_sex"
          image={image3}
          question={() => (
            <>
              <p>{t("steps.question_agree_only_sex.text1")}</p>
              <p>{t("steps.question_agree_only_sex.text2")}</p>
              <p>{t("steps.question_agree_only_sex.text3")}</p>
            </>
          )}
          buttons={[
            { text: t("steps.question_agree_only_sex.buttonNo"), id: "no" },
            { text: t("steps.question_agree_only_sex.buttonYes"), id: "yes" },
          ]}
          next={next}
        ></BasicQuestionForm>
      </Show>

      <Show when={currentStepIndex() == 3}>
        <BasicQuestionForm
          id="question_agree_use_condom"
          image={image4}
          question={() => <p>{t("steps.question_agree_use_condom.text1")}</p>}
          buttons={[
            { text: t("steps.question_agree_use_condom.buttonNo"), id: "no" },
            { text: t("steps.question_agree_use_condom.buttonYes"), id: "yes" },
          ]}
          next={next}
        ></BasicQuestionForm>
      </Show>
      <Show when={currentStepIndex() == 4}>
        <BasicQuestionForm
          id="question_end"
          image={image5}
          question={() => (
            <>
              <h1 class="text-2xl font-extrabold uppercase">
                {t("steps.question_end.title")}
              </h1>
              <p>{t("steps.question_end.text1")}</p>
            </>
          )}
          buttons={[
            { text: t("steps.question_end.buttonProceed"), id: "proceed" },
          ]}
          next={next}
        ></BasicQuestionForm>
      </Show>
    </div>
  );
}
